export default __webpack_public_path__ + "static/media/hero.d6f68574.svg";